module.exports = __webpack_public_path__ + "media/bootstrap-icons/eye-435abac1.svg";